export const LOGO_URL = "/logo.jpg";

export const CONTACT_EMAIL = "info@free-byte.com";
export const MAILTO = `mailto:${CONTACT_EMAIL}`;
